import React from "react"
import { useSettings } from "../editor"

const themes = {
  light: "https://cdn.convertkit.com/assets/light-built-with-badge.png",
  dark: "https://cdn.convertkit.com/assets/dark-built-with-badge.png",
  minimal: "https://cdn.convertkit.com/assets/minimal-built-with-badge.png"
}

export default function BuiltWithBadge({
  href = "https://kit.com",
  theme = "light",
  align = "center",
  spacing = "30px"
}) {
  const settings = useSettings()
  const shouldDisplay = settings.find(s => s.name === "builtWith.display")
    ?.value

  if (shouldDisplay === "false") {
    return null
  }

  const containerStyles = {
    textAlign: align,
    marginTop: spacing
  }

  const linkStyles = {
    display: "inline-block",
    textDecoration: "none"
  }

  const badgeStyles = {
    width: 190,
    height: 36
  }

  return (
    <div className="built-with" style={containerStyles}>
      <a href={href} target="_blank" rel="noopener" style={linkStyles}>
        <img
          src={themes[theme]}
          alt="Built with Kit"
          style={badgeStyles}
          width="190"
          height="36"
        />
      </a>
    </div>
  )
}
